(function () {
    var quickExitConfig = document.querySelector("[data-quick-exit-config]");
    var quickExitButton = document.querySelector("[data-quick-exit]");
    var storageKey = "magentaLivingQuickExitUrl";

    if (!quickExitConfig) {
        return;
    }

    var targetUrl = quickExitConfig.getAttribute("data-quick-exit-url");
    if (!targetUrl) {
        return;
    }

    function getStoredUrl() {
        try {
            return sessionStorage.getItem(storageKey);
        }
        catch (error) {
            return null;
        }
    }

    function setStoredUrl(url) {
        try {
            sessionStorage.setItem(storageKey, url);
        }
        catch (error) {
            // Ignore storage failures and continue with the redirect.
        }
    }

    function redirectToQuickExitUrl() {
        window.location.replace(targetUrl);
    }

    function shouldRedirectOnLoad() {
        var storedUrl = getStoredUrl();
        if (!storedUrl || storedUrl !== targetUrl) {
            return false;
        }

        var navigationEntries = window.performance && typeof window.performance.getEntriesByType === "function"
            ? window.performance.getEntriesByType("navigation")
            : [];
        var navigationType = navigationEntries.length ? navigationEntries[0].type : "";

        return navigationType === "back_forward";
    }

    if (shouldRedirectOnLoad()) {
        redirectToQuickExitUrl();
        return;
    }

    if (!quickExitButton) {
        return;
    }

    quickExitButton.addEventListener("click", function (event) {
        event.preventDefault();
        setStoredUrl(targetUrl);
        redirectToQuickExitUrl();
    });
})();
